module.exports = __webpack_public_path__ + "static/media/3_Prot_SD_OSA_20150626.bcc6b4d1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/3_Prot_SD_OSA_20150626.pdf
// module id = 186
// module chunks = 0